import React from 'react';
import { connect } from 'react-redux';
import Modal, { toggleModalByName } from 'src/universal/components/Modal';
import {
  Element,
  Color,
  Size,
  Typography,
  Icon
} from '@americanexpress/aqx-components';
import { getPdpHowYouEarnMobileHeaderModalText } from '../../redux';

import styles from './__styles__/index.scss?modules';

function ModalWrapper({ text }) {
  return (
    <Modal name="HOWYOUEARN-HEADER-MODAL" qeId="applyModal" styles={styles}>
      <Element
        className={styles.header}
        theme={{
          marginRight: 5
        }}
      >
        <button
          className={styles.iconButton}
          aria-label="toggle"
          onClick={() => toggleModalByName('HOWYOUEARN-HEADER-MODAL')}
        >
          <Icon
            directory="dls"
            imageName="dls-icon-close"
            $size={Size.SM}
            theme={{
              color: Color.BrightBlue
            }}
          />
        </button>
      </Element>
      <Element
        theme={{
          marginRight: 20,
          marginLeft: 10,
          marginBottom: 20
        }}
      >
        <Typography dangerouslySetInnerHTML={{ __html: text }} />
      </Element>
    </Modal>
  );
}

const mapStateToProps = state => ({
  text: getPdpHowYouEarnMobileHeaderModalText(state)
});

export default connect(mapStateToProps)(ModalWrapper);
